import React, { useEffect, useRef, useState } from 'react';
import TeacherWrapper from '../TeacherWrapper';
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi';
import { toast } from 'react-toastify';
import Modal from '../../components/modal';
import { MdClose } from 'react-icons/md';
import Input from '../../components/Input';
import moment from 'moment/moment';

const Attendance = () => {
  const [selectedDate, setSelectedDate] = useState(null);
  const [dateRange, setDateRange] = useState([]);
  const [myStudents, setMyStudents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [attendance, setAttendance] = useState('');
  const [isModalAbsentSecond, setIsModalAbsentSecond] = useState(false);
  const [remarks, setRemarks] = useState('');
  const [attendanceLoading, setAttendanceLoading] = useState({});
  
  const [isloading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const containerRef = useRef(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
    const [isModalAbsent, setIsModalAbsent] = useState(false);
  const [holdStartDate, setHoldStartDate] = useState(moment().format('YYYY-MM-DD'));
  const [holdEndDate, setHoldEndDate] = useState('');
  const [selectedStudent, setSelectedStudent] = useState(null);
  const scroll = (direction) => {
    const container = containerRef.current;
    const scrollAmount = direction === 'left' ? -150 : 150;
    container.scrollBy({ left: scrollAmount, behavior: 'smooth' });
  };

  useEffect(() => {
    const requestOptions = {
      method: 'GET',
      redirect: 'follow'
    };

    fetch('https://quran-backend-theta.vercel.app/v1/teacher/date-range', requestOptions)
      .then((response) => response.text())
      .then((result) => {
        let data = JSON.parse(result);
        setDateRange(data);

        const today = new Date();
        const todayDate = today.getDate();

        const defaultSelected = data.find(({ DATE }) => DATE === todayDate);
        setSelectedDate(defaultSelected ? todayDate : data[0].DATE);

        setLoading(false);
      })
      .catch((error) => {
        console.error(error);
        setLoading(false);
        setError('Failed to fetch date range data.');
      });
  }, []);

  const userDetails = localStorage.getItem('userData');
  const userData = JSON.parse(userDetails);

  useEffect(() => {
    FetchMyStudents();
  }, []);

  const FetchMyStudents = () => {
    setIsLoading(true);
    setError(null);

    const requestOptions = {
      method: 'GET',
      redirect: 'follow'
    };

    fetch(
      `https://quran-backend-theta.vercel.app/v1/teacher/my-students/${userData?._id}`,
      requestOptions
    )
      .then((response) => response.text())
      .then((result) => {
        let data = JSON.parse(result);
        // console.log("Student DATA", data);

        if (data?.success === false) {
          setError(data?.message);
          setIsLoading(false);
        } else if (data?.success === true) {
          setMyStudents(data?.data);
          setIsLoading(false);
        }
      })
      .catch((error) => {
        console.error(error);
        setIsLoading(false);
        setError('Failed to fetch student data.');
      });
  };

  const handleSelectChange = (event, studentId, course, startTime, endTime, session) => {
    const value = event.target.value;

    if (value === 'Hold') {
      setSelectedStudent({ studentId, course, startTime, endTime, session });
      setIsModalOpen(true);
      return;
    }

    if (value === 'Absent') {
      setSelectedStudent({ studentId, course, session });
      setIsModalAbsent(true);
      return;
    }

    updateAttendance(studentId, course, session, value);
  };

  const updateAttendance = (
    studentId,
    course,
    session,
    status,
    holdStartDate = null,
    holdEndDate = null
  ) => {
    setAttendanceLoading((prev) => ({ ...prev, [studentId]: true }));
    const myHeaders = new Headers();
    myHeaders.append('Content-Type', 'application/json');
    const raw = JSON.stringify({
      courseId: course,
      studentId: studentId,
      teacher: userData?._id,
      status: status,
      sessionTime: session,
      remarks:remarks,
      // holdStartDate: moment(holdStartDate).format('YYYY-MM-DD'),
      // holdEndDate: moment(holdEndDate).format('YYYY-MM-DD')
    });

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow'
    };

    fetch('https://quran-backend-theta.vercel.app/v1/teacher/attendance', requestOptions)
      .then((response) => response.json())
      .then((data) => {
        if (data?.success === false) {
          toast.error(data?.message);
        } else {
          toast.success('Attendance updated successfully!');
        }
        FetchMyStudents();
      })
      .catch((error) => {
        toast.error('Failed to update attendance.', error);
      })
      .finally(() => {
        setAttendanceLoading((prev) => ({ ...prev, [studentId]: false }));
      });
  };

  const handleSaveHold = () => {
    if (!holdStartDate || !holdEndDate) {
      toast.error('Please select both start and end dates for hold.');
      return;
    }
    const { studentId, course, session } = selectedStudent;
    updateAttendance(studentId, course, session, 'Hold', holdStartDate, holdEndDate);
    setIsModalOpen(false);
    setHoldStartDate('');
    setHoldEndDate('');
    setSelectedStudent(null);
  };



    const handleSaveAbsent = () => {
     
      const { studentId, course, session } = selectedStudent;
      updateAttendance(studentId, course, session, 'Absent', holdStartDate, holdEndDate);
      setIsModalAbsent(false);
      setHoldStartDate(moment().format('YYYY-MM-DD'));
      setHoldEndDate('');
      setRemarks('');
      setSelectedStudent(null);
    };


  
  return (
    <TeacherWrapper
      searchBar={
        <Input
          placeholder={`Search...`}
          Icon={
            <img src={require('../../assets/image/Search-Magnifier.png')} className=" w-8" alt="" />
          }
          className={' w-full bg-white  pl-12'}
        />
      }
    >
      <div className="flex justify-between items-center space-x-2 px-3 bg-[#D9D9D942] rounded-md">
        <button
          onClick={() => scroll('left')}
          className="text-white bg-primary rounded-full hover:bg-orange"
        >
          <FiChevronLeft className="w-6 h-6" />
        </button>

        <div
          ref={containerRef}
          className="flex justify-between w-full items-center space-x-2 overflow-x-auto scrollbar-hide"
        >
          {loading ? (
            <div>Loading...</div>
          ) : (
            dateRange?.map(({ month, DATE }) => (
              <button
                key={DATE}
                onClick={() => setSelectedDate(DATE)}
                className={`flex flex-col items-center px-6 py-2 ${selectedDate === DATE
                    ? ' bg-orange text-white font-bold'
                    : DATE === new Date().getDate()
                      ? ' bg-green-200 text-black font-bold'
                      : 'text-gray-800 hover:bg-gray-200'
                  } ${selectedDate !== DATE && 'cursor-not-allowed opacity-50'}`}
                disabled={selectedDate !== DATE}
              >
                <span className="text-sm font-medium">{month}</span>
                <span className="text-lg font-semibold">{DATE}</span>
              </button>
            ))
          )}
        </div>

        <button
          onClick={() => scroll('right')}
          className=" text-white bg-primary  rounded-full  hover:bg-orange"
        >
          <FiChevronRight className="w-6 h-6" />
        </button>
      </div>

      <section className="mb-20 mt-7">
        <div className="rounded-lg overflow-x-auto">
          <div className="flex flex-col">
            <div className=" sm:-mx-6 lg:-mx-8 ">
              <div className="inline-block min-w-full sm:px-6 lg:px-8 ">
                <div className="overflow-hidden">
                  {isloading ? (
                    <div>Loading...</div>
                  ) : error ? (
                    <div>{error}</div>
                  ) : (
                    <table className="min-w-full mb-0">
                      <thead className=" ">
                        <tr className="rounded-lg whitespace-nowrap ">
                        <th className="text-sm text-primary font-bold px-6 py-4">Sr No.</th>
                        <th className="text-sm text-primary font-bold px-6 py-4">ID</th>

                          <th scope="col" className=" text-sm text-primary font-bold px-6 py-4">
                            Name
                          </th>
                          <th scope="col" className="text-sm text-primary font-bold px-6 py-4">
                            Course
                          </th>
                          <th scope="col" className="text-sm text-primary font-bold px-6 py-4">
                            Country
                          </th>
                          <th scope="col" className="text-sm text-primary font-bold px-6 py-4">
                            Timing
                          </th>
                          <th scope="col" className="text-sm text-primary font-bold px-6 py-4">
                            Remarks
                          </th>
                          <th scope="col" className="text-sm text-primary font-bold px-6 py-4">
                            Mark Attendance
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {myStudents?.length > 0 ? (
                          myStudents?.map((student,index) => (
                            <tr
                              key={student?.enrollment?._id}
                              className="bg-white border-b-8 border-white rounded-md"
                            >
                              <td className="align-middle bg-white text-sm font-normal px-6 py-3 whitespace-nowrap text-center">
                                <span className="bg-green-200 text-base text-black py-1 px-2.5 leading-none text-center whitespace-nowrap align-baseline rounded-full">
                                  {index + 1}
                                </span>
                              </td>
                              
                              <td className="align-middle whitespace-nowrap bg-white text-sm font-normal px-6 py-4 text-center">
                                <span className="text-base text-black py-1 px-2.5 bg-green-200 rounded-full">
                                  {student?.enrollment?.userDetails?.studentId}
                                </span>
                              </td>
                              <td className="align-middle bg-white text-sm font-normal px-6 py-3 text-center">
                                <span className="bg-white text-base text-black py-1 px-2.5 leading-none text-center whitespace-nowrap align-baseline bg-green-200 rounded-full">
                                  {student?.enrollment?.studentName}
                                </span>
                              </td>
                              <td className="text-sm bg-white font-normal text-center px-6 py-4 whitespace-nowrap">
                                <span className="text-base text-black py-1 px-2.5 leading-none text-center whitespace-nowrap align-baseline bg-green-200 rounded-full">
                                  {student?.enrollment?.courseName}
                                </span>
                              </td>
                              <td className="align-middle bg-white text-center text-sm font-normal px-6 py-4 whitespace-nowrap text-left">
                                <span className="text-base text-black py-1 px-2.5 leading-none whitespace-nowrap bg-green-200 rounded-full">
                                  {student?.enrollment?.country}
                                </span>
                              </td>
                              <td className="align-middle bg-white text-center text-sm font-normal px-6 py-4 whitespace-nowrap text-left">
                                {student?.timeSlots?.map((item, index) => {
                                  return (
                                    <span
                                      key={index}
                                      className="text-base text-black py-1 px-2.5 bg-green-200 rounded-full"
                                    >
                                      {item?.startTime} - {item?.endTime}
                                    </span>
                                  );
                                })}
                              </td>
                              <td className="align-middle bg-white text-center text-sm font-normal px-6 py-4 whitespace-nowrap text-left">
                                <span className="text-base text-black py-1 px-2.5 leading-none whitespace-nowrap bg-green-200 rounded-full">
                                  {student?.enrollment?.attendanceRemarks?student?.enrollment?.attendanceRemarks:'-'}
                                </span>
                              </td>
                              <td className="align-middle bg-white text-center text-sm font-normal px-6 py-4 whitespace-nowrap text-left">
                                {attendanceLoading[student?.enrollment?.userDetails?._id] ? (
                                  <div className="text-[gray] bg-[#3FFF801F] px-3 py-2 rounded-md">
                                    Loading...
                                  </div>
                                ) : (
                                  <>
                                    {student?.enrollment?.todayAttendance === '-' ? (
                                      <select
                                        value={attendance}
                                        onChange={(e) =>
                                          handleSelectChange(
                                            e,
                                            student?.enrollment?.userDetails?._id,
                                            student?.enrollment?.course,
                                            student?.startTime,
                                            student?.endTime,
                                            student?.timeSlots
                                          )
                                        }
                                        className="text-[#23A118] bg-[#3FFF801F] px-3 py-2 rounded-md"
                                      >
                                        <option value="" disabled>
                                          Select
                                        </option>
                                        <option value="Present">Present</option>
                                        <option value="Absent">Absent</option>
                                        <option value="Leave">Leave</option>
                                        {/* <option value="Hold">Hold</option> */}
                                      </select>
                                    ) : (
                                      <h3
                                        className={`  w-20 text-sm mx-auto py-1 rounded-md ${student?.enrollment?.todayAttendance === 'Present'
                                            ? 'bg-[#DFF7E3] text-[#23A118]'
                                            : student?.enrollment?.todayAttendance === 'Absent'
                                              ? 'bg-[#FFE4E4] text-[#FF0000]'
                                              : student?.enrollment?.todayAttendance === 'Hold'
                                                ? 'bg-[#FFF3E0] text-[#FFA500]'
                                                : student?.enrollment?.todayAttendance === 'Leave'
                                                  ? 'bg-[#E0F7FA] text-[#00BCD4]'
                                                  : 'bg-gray-200 text-black'
                                          }`}
                                      >
                                        {student?.enrollment?.todayAttendance}
                                      </h3>
                                    )}
                                  </>
                                )}
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="5" className="text-center text-sm font-normal py-4">
                              No students available
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Modal for Hold Attendance */}
      <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
        <div className="p-3 flex justify-between items-center">
          <span></span>
          <h1 className="capitalize h4 font-medium">Hold Attendance</h1>
          <MdClose onClick={() => setIsModalOpen(false)} size={25} className="cursor-pointer" />
        </div>
        <hr />
        <div className="p-5">
          <form className=" flex  justify-between items-center">
            <div className="w-[48%]">
              <Input
                type={'date'}
                label={'Hold Start Date'}
                placeholder={''}
                className={'bg-gray-100 px-2 w-full'}
                name="holdStartDate"
                value={holdStartDate}
                onChange={(e) => setHoldStartDate(e.target.value)}
              />
            </div>
            <div className="w-[48%]">
              <Input
                type={'date'}
                label={'Hold End Date'}
                placeholder={''}
                className={'bg-gray-100 px-2 w-full'}
                name="holdEndDate"
                value={holdEndDate}
                onChange={(e) => setHoldEndDate(e.target.value)}
              />
            </div>
          </form>
          <div className=" flex justify-center items-center">
            <button
              onClick={handleSaveHold}
              className="mt-4  bg-secondary w-60 mx-auto text-white px-4 py-2 rounded-md hover:bg-orange"
            >
              Save
            </button>
          </div>
        </div>
      </Modal>

      

        <Modal isOpen={isModalAbsent} onClose={() => setIsModalAbsent(false)}>
          <div className="p-3 flex justify-between items-center">
            <span></span>
            <h1 className="capitalize h4 font-medium">Absent Attendance</h1>
            <MdClose onClick={() => setIsModalAbsent(false)} size={25} className="cursor-pointer" />
          </div>
          <hr />
          <div className="p-5">
            <form className="flex justify-between flex-wrap items-center">
           
              <div className="w-full mt-4">
                <label className="block text-sm font-medium text-gray-700 mb-1">Remarks</label>
                <textarea 
                  rows={4} 
                  name="remarks" 
                  className='bg-gray-100 px-2 w-full outline-none py-3.5 text-black placeholder:text-primary rounded-md'
                  value={remarks}
                  onChange={(e) => setRemarks(e.target.value)} 
                  placeholder="Enter remarks (required for Hold status)"
                />
              </div>
            </form>
            <div className="flex justify-center items-center mt-4">
              <button
                onClick={handleSaveAbsent}
                className="bg-secondary w-60 mx-auto text-white px-4 py-2 rounded-md hover:bg-orange disabled:opacity-50"
                disabled={!remarks}
              >
                Save
              </button>
            </div>
          </div>
        </Modal>

    </TeacherWrapper>
  );
};

export default Attendance;
